module.exports = __webpack_public_path__ + "544fa4f2678a8285eb88b8dfe503c90c.ttf";